import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layouts/paginated-layout.js";
import { Subpage, Callout } from "course-components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Subpage slug="numbers-and-math" mdxType="Subpage">
      <h3>{`Numbers and Math`}</h3>
      <p>{`In this module we'll take a short break from IxD1 and focus just on basic scripting principles. Specific scripting skills we'll cover include:`}</p>
      <Callout color="secondary" mdxType="Callout">
        <p>{`Read the following from the Duckett text:`}</p>
        <ul>
          <li parentName="ul">{`Ch. 1c`}</li>
          <li parentName="ul">{`Ch. 2, pp.53-63, 69, 74-77`}</li>
        </ul>
      </Callout>
      <p>{`Note that we skip some sections here but will return to them in later modules. You are welcome to skim them.`}</p>
    </Subpage>
    <Subpage slug="presentation-and-demo" mdxType="Subpage">
      <h3>{`Presentation and Demo`}</h3>
      <p>{`Watch this presentation and play along in the demo provided in CULearn. Use `}<a parentName="p" {...{
          "href": "/docs/vcd-3650-lesson-2.pdf"
        }}>{`this handout`}</a>{` to take notes.`}</p>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/XNujdelUXuM?list=PLuOViGmL7TfUvXLsGu6JfBCAq-rF2iSQz" frameborder="0" allowfullscreen></iframe>
      <h4>{`Study Questions`}</h4>
      <ol>
        <li parentName="ol">{`What is progressive enhancement?`}</li>
        <li parentName="ol"><strong parentName="li">{`SKILL:`}</strong>{` Create a JavaScript file.`}</li>
        <li parentName="ol"><strong parentName="li">{`SKILL:`}</strong>{` Add JavaScript to HTML documents directly and by linking to separate scripts.`}</li>
        <li parentName="ol">{`What are statements?`}</li>
        <li parentName="ol">{`What are comments?`}</li>
        <li parentName="ol"><strong parentName="li">{`SKILL:`}</strong>{` Add single-line and multi-line comments in JavaScript.`}</li>
        <li parentName="ol">{`What is a variable?`}</li>
        <li parentName="ol"><strong parentName="li">{`SKILL:`}</strong>{` Declare variables and assign them values in JavaScript.`}</li>
        <li parentName="ol">{`What are data types?`}</li>
        <li parentName="ol">{`List three of the common data types.`}</li>
        <li parentName="ol"><strong parentName="li">{`SKILL:`}</strong>{` Output content to the browser console.`}</li>
      </ol>
    </Subpage>
    <Subpage slug="commit-to-memory" mdxType="Subpage">
      <h3>{`Commit to Memory`}</h3>
      <p>{`The `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`var`}</code>{` keyword and its use.`}</p>
      <p>{`The following mathematical operators and their use:`}</p>
      <ul>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`+`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`-`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`*`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`/`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`%`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`++`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`--`}</code></li>
      </ul>
      <p>{`The following assignment operators and their use:`}</p>
      <ul>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`=`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`+=`}</code></li>
        <li parentName="ul"><code parentName="li" {...{
            "className": "language-text"
          }}>{`-=`}</code></li>
      </ul>
      <p>{`The expression syntax:`}</p>
      <p><code parentName="p" {...{
          "className": "language-text"
        }}>{`__v1__  _o_  __v2__`}</code>{`
: `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`v1`}</code>{` and `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`v2`}</code>{` are values; `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`o`}</code>{` is an operator`}</p>
      <p>{`The console log syntax:`}</p>
      <p><code parentName="p" {...{
          "className": "language-text"
        }}>{`console.log(__1__);`}</code>{`
: `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`1`}</code>{` is any valid value be literal data or an expression`}</p>
    </Subpage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      